module.exports = __webpack_public_path__ + "static/img/role-es.138c522.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/role-2/role-es.png
// module id = 1/A1
// module chunks = 1